import { MiniMapZoomControlsProps } from "./types";

export const MiniMapZoomControls = ({
  handleZoomIn,
  handleZoomOut,
  handleResetZoom,
}: MiniMapZoomControlsProps) => {
  return (
    <div className="absolute right-2 top-12 flex flex-col gap-1 z-40">
      <button
        type="button"
        onClick={handleZoomIn}
        className="w-8 h-8 rounded bg-black/60 text-white hover:bg-black/75"
        title="Zoom in"
      >
        +
      </button>
      <button
        type="button"
        onClick={handleZoomOut}
        className="w-8 h-8 rounded bg-black/60 text-white hover:bg-black/75"
        title="Zoom out"
      >
        −
      </button>
      <button
        type="button"
        onClick={handleResetZoom}
        className="w-8 h-8 rounded bg-black/60 text-white hover:bg-black/75 text-xs"
        title="Reset"
      >
        1:1
      </button>
    </div>
  );
};
